
<section>
    <div class="rule-5190-container" *ngFor="let table of tables">
      <div class="table-header">
        <div class="table-title">
          <span
            class="link-btn pdf"
            (click)="switchView('table')"
            [ngClass]="{ 'link-inactive': viewType == 'chart' }"
          >
            {{ tableNames[table] }}
          </span>
          <span class="link-inactive">|</span>
          <span
            class="link-btn"
            (click)="switchView('chart')"
            [ngClass]="{ 'link-inactive': viewType == 'table' }"
          >
            Charts
          </span>
        </div>
      </div>
      <div>
        <div *ngIf="showView('table')">
          <report-finra-grid
            class="pdf"
            style="xwidth:3000px;display:block;"
            #reportfinragrid
            id="id"
            [containerCssStyle]="table === 'dealType' ? { 'margin-bottom': '0' } : {}"
            [columnDefs]="columnDefs[table]"
            [rowData]="tableData[table]"
            [groupDefaultExpanded]="0"
            [gridOptions]="gridOptions"
            [autoResize]="true"
            [sizeToFitOnly]="true"
            [defaultColDef]="{ wrapHeaderText: true, autoHeaderHeight: true }"
          ></report-finra-grid>
          <report-finra-grid
            *ngIf="table === 'dealType'"
            class="pdf"
            style="xwidth:3000px;display:block;"
            #reportfinragrid
            id="id"
            [columnDefs]="columnDefs['dealType_2']"
            [rowData]="tableData['dealType_2']"
            [groupDefaultExpanded]="0"
            [gridOptions]="gridOptions"
            [autoResize]="true"
            [sizeToFitOnly]="true"
            [defaultColDef]="{ wrapHeaderText: true, autoHeaderHeight: true }"
          ></report-finra-grid>
        </div>
        <div *ngIf="showView('chart')" class="chart-container">
          <report-finra-chart
            *ngIf="table !== 'dealType'"
            [template]="'line-chart'"
            [rowData]="chartData[table]"
            [legendLabel]="'Legend'"
            [legendPosition]="'right'"
            [showLegend]="true"
            [autoScale]="true"
            [xAxisLabel]="lineChartOptions[table]['xAxisLabel']"
            [yAxisLabel]="lineChartOptions[table]['yAxisLabel']"
            [yAxisTickFormatting]="table === 'submissionTotals' ? formatPercent : undefined"
            [scheme]="colorScheme"
          ></report-finra-chart>
          <report-finra-chart
            *ngIf="table === 'dealType'"
            [template]="'advanced-pie'"
            [rowData]="chartData[table]"
            [pieLabel]="'Total Exceptions'"
            [showLegend]="true"
            [customColors]="customColorsFunction"
          ></report-finra-chart>
        </div>
      </div>
    </div>
</section>